import { Appointment } from "@elixir/types";
import { DatePicker, Popover, notification } from "antd";
import dateFormat from "dateformat";
import React from "react";
import usePostAddAppointmentFollowupDate from "../../../../apis/tryst/post-add-appointment-followup-date";
import { ReactComponent as RepeatRegularIcon } from "../../../../assets/icons/font-awesome/repeat-regular.svg";
import { ChipWithTooltip } from "ui";

const FollowUp = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  const { mutateAsync: postAddAppointmentFollowupDate } =
    usePostAddAppointmentFollowupDate();
  const [open, setOpen] = React.useState(false);
  const isFollowupDatePresent = !!apt.follow_up;
  return (
    <Popover
      placement="top"
      showArrow={false}
      trigger="click"
      className="dr-cursor-pointer"
      content={() => (
        <DatePicker
          className="flex-1 text-center"
          suffixIcon={null}
          open={open && !isFollowupDatePresent}
          onOpenChange={(open) => setOpen(open)}
          onChange={async (value) => {
            if (!value) return;

            const response = await postAddAppointmentFollowupDate({
              appointment: apt,
              follow_up: value.toDate(),
            });

            if (response.success) {
              notification.success({
                message: "Follow Up Date Added",
                description: `Your follow up appointment with ${
                  apt.patient.fln
                } has been scheduled on ${dateFormat(
                  value.format("yyyy-MM-DD"),
                  "ddS mmmm, yyyy"
                )}.`,
                placement: "bottomRight",
              });
              setOpen(false);
            } else {
              notification.error({
                message: "Error in adding follow up date",
                description: response.error,
                placement: "bottomRight",
              });
            }
          }}
          clearIcon={null}
          allowClear={false}
          bordered={false}
          style={{ padding: 0, border: 0, boxShadow: "none" }}
          inputRender={() => <></>}
        />
      )}
      destroyTooltipOnHide={true}
      overlayClassName="popover-p-0"
    >
      <ChipWithTooltip
        selected={isFollowupDatePresent}
        onClick={() => {
          setOpen(true);
          // postMarkNoShowAppointment(apt);
        }}
        className={`h-32 flex-1 ${className}`}
        icon={<RepeatRegularIcon className="dr-min-w-14 dr-w-14 dr-h-14" />}
        title={
          isFollowupDatePresent
            ? dateFormat(apt.follow_up, "ddS mmmm, yyyy")
            : "Follow Up"
        }
        tooltipText={
          isFollowupDatePresent
            ? dateFormat(apt.follow_up, "ddS mmmm, yyyy")
            : "Follow Up"
        }
        type={type}
      />
    </Popover>
  );
};

export default FollowUp;
